
import { useContext } from 'react';
import { DialogStateContextType } from './DialogStateTypes';
import { DialogStateContext } from './DialogStateContext';

/**
 * Hook to access the DialogState context values
 * @returns The dialog state context value
 * @throws Error if used outside of a DialogStateProvider
 */
export const useDialogState = () => {
  const context = useContext<DialogStateContextType | undefined>(DialogStateContext);
  if (context === undefined) {
    throw new Error("useDialogState must be used within a DialogStateProvider");
  }
  return context;
};
